import { useTranslation } from 'react-i18next';

export function FreeformSection({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) {
  const { t } = useTranslation('intake');
  return (
    <div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={1000}
        rows={4}
        placeholder={t('freeformPlaceholder')}
        className="w-full rounded-md border border-synergy-neutral-700/40 bg-white/60 px-3 py-2 text-sm"
      />
      <div className="mt-1 text-right text-[10px] text-synergy-text-tertiary">
        {value.length} / 1000
      </div>
    </div>
  );
}
